var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/sms"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.75 16.0244H5.25C2.5125 16.0244 0.9375 14.4494 0.9375 11.7119V6.46191C0.9375 3.72441 2.5125 2.14941 5.25 2.14941H12.75C15.4875 2.14941 17.0625 3.72441 17.0625 6.46191V11.7119C17.0625 14.4494 15.4875 16.0244 12.75 16.0244ZM5.25 3.27441C3.105 3.27441 2.0625 4.31691 2.0625 6.46191V11.7119C2.0625 13.8569 3.105 14.8994 5.25 14.8994H12.75C14.895 14.8994 15.9375 13.8569 15.9375 11.7119V6.46191C15.9375 4.31691 14.895 3.27441 12.75 3.27441H5.25Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.99983 9.73939C8.36983 9.73939 7.73234 9.54439 7.24484 9.14689L4.89733 7.27189C4.65733 7.07689 4.61234 6.72439 4.80734 6.48439C5.00234 6.24439 5.35484 6.19939 5.59484 6.39439L7.94233 8.26939C8.51233 8.72689 9.47983 8.72689 10.0498 8.26939L12.3973 6.39439C12.6373 6.19939 12.9973 6.23689 13.1848 6.48439C13.3798 6.72439 13.3423 7.08439 13.0948 7.27189L10.7473 9.14689C10.2673 9.54439 9.62983 9.73939 8.99983 9.73939Z",
    fill: "#053CC8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.09ebc0bbc6636ea6847aa452127dc081.svg";
export { ForwardRef as ReactComponent };